import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '@mui/material';
import CustomButton from 'lib/designSystem/Button';
import ColoredCircle from 'lib/designSystem/ColoredCircle';
import EnhancedTable from 'lib/designSystem/Table';
import { CHART_COLORS } from 'lib/functions/const/colors';
import React from 'react';

function getFirstColumnLabel(title: string): string {
  switch (title) {
    case 'Saldo documentos por tramo vencimiento':
      return 'Tramo vencimiento';
    case 'Saldo documentos por estado':
      return 'Estado cobranza';
    case 'Saldo documentos por subestado cobranza':
      return 'Subestado cobranza';
    case 'Saldo documentos por producto':
      return 'Producto';
    default:
      return title;
  }
}

type DetailsDialogProps = {
  openDialog: boolean;
  handleDialogClose: () => void;
  title: string;
  data: { name: string; value: number }[];
};

const DetailsDialog = ({
  openDialog,
  handleDialogClose,
  title,
  data,
}: DetailsDialogProps) => {
  const totalValue = data.reduce((acc, curr) => acc + curr.value, 0);
  const dataWithPercentage = data
    .map((item) => ({
      ...item,
      percentage: item.value / totalValue,
    }))
    .sort((a, b) => b.value - a.value);
  const firstColumnLabel = getFirstColumnLabel(title);
  return (
    <Dialog open={openDialog} onClose={handleDialogClose} maxWidth="lg">
      <DialogTitle>
        <ColoredCircle color={CHART_COLORS.blue} size={15} />
        {` ${title}`}
      </DialogTitle>
      <DialogContent>
        <EnhancedTable
          dataHeaders={[
            { key: 'name', label: firstColumnLabel },
            { key: 'value', label: 'Monto', type: 'money' },
            { key: 'percentage', label: '%', type: 'percentage' },
          ]}
          data={dataWithPercentage}
          rowsPerPageDefault={100}
          finalSumRow
          exportToFile="xlsx"
        />
      </DialogContent>
      <DialogActions>
        <CustomButton onClick={handleDialogClose}>Cerrar</CustomButton>
      </DialogActions>
    </Dialog>
  );
};

export default DetailsDialog;
